import React from "react";

//Redux
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
//Action
import * as myProfileAction from '../action/myProfileAction';
//Material-ui
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';

class Comp extends React.Component {

  componentDidMount() {
    this.props.myProfileGet();
  }

  render() {
    return (
      <div style={{maxWidth:'400px', margin:'auto'}}>

        <div style={{margin:'15px'}}>
          <Box className='postItem round12' boxShadow={2} style={{background:'#FFF'}}>
            <div style={{padding:'10px'}}>
              <h2 align='center'>おめでとうございます</h2>
              <div>
                <div>
                  カップリングが成立いたしました。
                </div>
                <div>
                  ホームにカップリングボックスが表示されます。
                </div>
              </div>

              <div align='center'>
                <Button
                  variant="outlined"
                  color="primary"
                  onClick={ () => this.props.history.push('/') }
                >
                  ホーム
                </Button>
              </div>
            </div>
          </Box>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
	return {
    my: state.my,
	}
};
const mapDispatchToProps = dispatch => (
	bindActionCreators({
    ...myProfileAction,
	}, dispatch)
);

export default connect(mapStateToProps, mapDispatchToProps)(Comp);
